/// <reference types="./copilot_message.d.mts" />
import * as $json from "../../gleam_json/gleam/json.mjs";
import * as $bool from "../../gleam_stdlib/gleam/bool.mjs";
import * as $decode from "../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $list from "../../gleam_stdlib/gleam/list.mjs";
import * as $option from "../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../gleam_stdlib/gleam/result.mjs";
import * as $string from "../../gleam_stdlib/gleam/string.mjs";
import * as $calendar from "../../gleam_time/gleam/time/calendar.mjs";
import * as $timestamp from "../../gleam_time/gleam/time/timestamp.mjs";
import * as $metadata from "../data/copilot_message/metadata.mjs";
import * as $decrypt from "../decrypt.mjs";
import {
  Ok,
  Error,
  toList,
  Empty as $Empty,
  prepend as listPrepend,
  CustomType as $CustomType,
} from "../gleam.mjs";

export class Display extends $CustomType {
  constructor(score, tags) {
    super();
    this.score = score;
    this.tags = tags;
  }
}

export class Answer extends $CustomType {
  constructor(short, long, yes_no, custom) {
    super();
    this.short = short;
    this.long = long;
    this.yes_no = yes_no;
    this.custom = custom;
  }
}

export class Copilot extends $CustomType {}

export class Conversation extends $CustomType {}

export class Slack extends $CustomType {}

export class CopilotMessage extends $CustomType {
  constructor(id, org_id, thread_id, user_id, created_at, updated_at, data_points_id, display, metadata, kind) {
    super();
    this.id = id;
    this.org_id = org_id;
    this.thread_id = thread_id;
    this.user_id = user_id;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.data_points_id = data_points_id;
    this.display = display;
    this.metadata = metadata;
    this.kind = kind;
  }
}

export class CopilotQuestion extends $CustomType {
  constructor(id, org_id, thread_id, user_id, created_at, updated_at, data_points_id, display, metadata, kind, loading, content, answer) {
    super();
    this.id = id;
    this.org_id = org_id;
    this.thread_id = thread_id;
    this.user_id = user_id;
    this.created_at = created_at;
    this.updated_at = updated_at;
    this.data_points_id = data_points_id;
    this.display = display;
    this.metadata = metadata;
    this.kind = kind;
    this.loading = loading;
    this.content = content;
    this.answer = answer;
  }
}

function kind_decoder() {
  return $decode.then$(
    $decode.string,
    (kind) => {
      if (kind === "copilot") {
        return $decode.success(new Copilot());
      } else if (kind === "conversation") {
        return $decode.success(new Conversation());
      } else if (kind === "slack") {
        return $decode.success(new Slack());
      } else {
        return $decode.failure(new Copilot(), "kind");
      }
    },
  );
}

export function extract_data_points_id(message) {
  let data_points_id = $metadata.data_points_id(message.metadata);
  let data_points_id$1 = $result.unwrap(data_points_id, toList([]));
  if (message instanceof CopilotMessage) {
    let _record = message;
    return new CopilotMessage(
      _record.id,
      _record.org_id,
      _record.thread_id,
      _record.user_id,
      _record.created_at,
      _record.updated_at,
      data_points_id$1,
      _record.display,
      _record.metadata,
      _record.kind,
    );
  } else {
    let _record = message;
    return new CopilotQuestion(
      _record.id,
      _record.org_id,
      _record.thread_id,
      _record.user_id,
      _record.created_at,
      _record.updated_at,
      data_points_id$1,
      _record.display,
      _record.metadata,
      _record.kind,
      _record.loading,
      _record.content,
      _record.answer,
    );
  }
}

export function extract_score(message) {
  let score = $metadata.score(message.metadata);
  let score$1 = $option.from_result(score);
  let _block;
  let _record = message.display;
  _block = new Display(score$1, _record.tags);
  let display = _block;
  if (message instanceof CopilotMessage) {
    let _record$1 = message;
    return new CopilotMessage(
      _record$1.id,
      _record$1.org_id,
      _record$1.thread_id,
      _record$1.user_id,
      _record$1.created_at,
      _record$1.updated_at,
      _record$1.data_points_id,
      display,
      _record$1.metadata,
      _record$1.kind,
    );
  } else {
    let _record$1 = message;
    return new CopilotQuestion(
      _record$1.id,
      _record$1.org_id,
      _record$1.thread_id,
      _record$1.user_id,
      _record$1.created_at,
      _record$1.updated_at,
      _record$1.data_points_id,
      display,
      _record$1.metadata,
      _record$1.kind,
      _record$1.loading,
      _record$1.content,
      _record$1.answer,
    );
  }
}

export function update_metadata(message, metadata) {
  let created_at = $timestamp.system_time();
  let _block;
  if (message instanceof CopilotMessage) {
    let _record = message;
    _block = new CopilotMessage(
      _record.id,
      _record.org_id,
      _record.thread_id,
      _record.user_id,
      created_at,
      _record.updated_at,
      _record.data_points_id,
      _record.display,
      metadata,
      _record.kind,
    );
  } else {
    let _record = message;
    _block = new CopilotQuestion(
      _record.id,
      _record.org_id,
      _record.thread_id,
      _record.user_id,
      created_at,
      _record.updated_at,
      _record.data_points_id,
      _record.display,
      metadata,
      _record.kind,
      _record.loading,
      _record.content,
      _record.answer,
    );
  }
  let _pipe = _block;
  let _pipe$1 = extract_data_points_id(_pipe);
  return extract_score(_pipe$1);
}

export function display_decoder() {
  return $decode.field(
    "score",
    $decode.optional($decode.float),
    (score) => {
      return $decrypt.optional_field(
        "tags",
        $decode.list($decode.string),
        (tags) => {
          let tags$1 = $option.unwrap(tags, toList([]));
          return $decode.success(new Display(score, tags$1));
        },
      );
    },
  );
}

export function answer_decoder() {
  return $decode.map(
    $decode.optional(
      $decode.field(
        "short",
        $decode.optional($decode.string),
        (short) => {
          return $decode.field(
            "long",
            $decode.optional($decode.string),
            (long) => {
              return $decode.field(
                "yes_no",
                $decode.optional($decode.string),
                (yes_no) => {
                  return $decode.field(
                    "custom",
                    $decode.optional($decode.string),
                    (custom) => {
                      return $decode.success(
                        new Answer(short, long, yes_no, custom),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      ),
    ),
    (content) => {
      let _pipe = new Answer(new None(), new None(), new None(), new None());
      return ((_capture) => { return $option.unwrap(content, _capture); })(
        _pipe,
      );
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    (() => {
      let _pipe = $decode.string;
      return $decode.map(_pipe, $string.lowercase);
    })(),
    (id) => {
      let thread_id = $decode.map($decode.string, $string.lowercase);
      return $decode.field(
        "thread_id",
        thread_id,
        (thread_id) => {
          return $decode.field(
            "display",
            $decrypt.json(display_decoder()),
            (display) => {
              return $decode.field(
                "user_id",
                $decode.string,
                (user_id) => {
                  return $decode.field(
                    "org_id",
                    $decode.string,
                    (org_id) => {
                      return $decode.field(
                        "updated_at",
                        $decrypt.timestamp(),
                        (updated_at) => {
                          return $decode.field(
                            "data_points_id",
                            (() => {
                              let _pipe = $decode.optional(
                                $decode.list($decrypt.uuid()),
                              );
                              return $decode.map(
                                _pipe,
                                (_capture) => {
                                  return $option.unwrap(_capture, toList([]));
                                },
                              );
                            })(),
                            (data_points_id) => {
                              return $decode.field(
                                "created_at",
                                $decrypt.timestamp(),
                                (created_at) => {
                                  return $decode.field(
                                    "kind",
                                    kind_decoder(),
                                    (kind) => {
                                      return $decode.field(
                                        "metadata",
                                        $decrypt.json($metadata.decoder()),
                                        (metadata) => {
                                          return $bool.guard(
                                            $metadata.is_deprecated(metadata),
                                            $decode.field(
                                              "answer",
                                              $decrypt.json(answer_decoder()),
                                              (answer) => {
                                                return $decode.field(
                                                  "content",
                                                  $decode.string,
                                                  (content) => {
                                                    return $decode.field(
                                                      "loading",
                                                      $decode.bool,
                                                      (loading) => {
                                                        return $decode.success(
                                                          new CopilotQuestion(
                                                            id,
                                                            org_id,
                                                            thread_id,
                                                            user_id,
                                                            created_at,
                                                            updated_at,
                                                            data_points_id,
                                                            display,
                                                            metadata,
                                                            kind,
                                                            loading,
                                                            content,
                                                            answer,
                                                          ),
                                                        );
                                                      },
                                                    );
                                                  },
                                                );
                                              },
                                            ),
                                            () => {
                                              return $decode.success(
                                                new CopilotMessage(
                                                  id,
                                                  org_id,
                                                  thread_id,
                                                  user_id,
                                                  created_at,
                                                  updated_at,
                                                  data_points_id,
                                                  display,
                                                  metadata,
                                                  kind,
                                                ),
                                              );
                                            },
                                          );
                                        },
                                      );
                                    },
                                  );
                                },
                              );
                            },
                          );
                        },
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

export function encode_kind(kind) {
  if (kind instanceof Copilot) {
    return $json.string("copilot");
  } else if (kind instanceof Conversation) {
    return $json.string("conversation");
  } else {
    return $json.string("slack");
  }
}

export function encode_answer(message) {
  if (message instanceof CopilotMessage) {
    return $json.object(toList([]));
  } else {
    return $json.object(
      toList([
        ["short", $json.nullable(message.answer.short, $json.string)],
        ["long", $json.nullable(message.answer.long, $json.string)],
        ["custom", $json.nullable(message.answer.custom, $json.string)],
        ["yes_no", $json.nullable(message.answer.yes_no, $json.string)],
      ]),
    );
  }
}

export function encode_display(display) {
  return $json.object(
    toList([
      ["score", $json.nullable(display.score, $json.float)],
      ["tags", $json.array(display.tags, $json.string)],
    ]),
  );
}

export function encode(question) {
  let created_at = $timestamp.to_rfc3339(
    question.created_at,
    $calendar.utc_offset,
  );
  let updated_at = $timestamp.to_rfc3339(
    question.updated_at,
    $calendar.utc_offset,
  );
  let shared = toList([
    ["id", $json.string(question.id)],
    ["thread_id", $json.string(question.thread_id)],
    ["display", encode_display(question.display)],
    ["user_id", $json.string(question.user_id)],
    ["org_id", $json.string(question.org_id)],
    ["created_at", $json.string(created_at)],
    ["updated_at", $json.string(updated_at)],
    ["kind", encode_kind(question.kind)],
    ["data_points_id", $json.array(question.data_points_id, $json.string)],
    ["metadata", $metadata.encode(question.metadata)],
  ]);
  if (question instanceof CopilotMessage) {
    return $json.object(shared);
  } else {
    return $json.object(
      listPrepend(
        ["loading", $json.bool(question.loading)],
        listPrepend(
          ["content", $json.string(question.content)],
          listPrepend(["answer", encode_answer(question)], shared),
        ),
      ),
    );
  }
}

export function answer(message) {
  if (message instanceof CopilotMessage) {
    return new $option.None();
  } else {
    let _pipe = message.answer.long;
    let _pipe$1 = $option.or(_pipe, message.answer.short);
    return $option.or(_pipe$1, message.answer.yes_no);
  }
}

export function content(message) {
  if (message instanceof CopilotMessage) {
    let metadata = message.metadata;
    if (metadata instanceof $metadata.Deprecated) {
      return "";
    } else if (metadata instanceof $metadata.Errored) {
      return "";
    } else if (metadata instanceof $metadata.System) {
      return metadata.content;
    } else if (metadata instanceof $metadata.Developer) {
      return metadata.content;
    } else if (metadata instanceof $metadata.User) {
      return metadata.content;
    } else if (metadata instanceof $metadata.Tool) {
      return metadata.content;
    } else {
      return $option.unwrap(metadata.content, "");
    }
  } else {
    return message.content;
  }
}

export function change_user(message, user_id, org_id) {
  if (message instanceof CopilotMessage) {
    let _record = message;
    return new CopilotMessage(
      _record.id,
      org_id,
      _record.thread_id,
      user_id,
      _record.created_at,
      _record.updated_at,
      _record.data_points_id,
      _record.display,
      _record.metadata,
      _record.kind,
    );
  } else {
    let _record = message;
    return new CopilotQuestion(
      _record.id,
      org_id,
      _record.thread_id,
      user_id,
      _record.created_at,
      _record.updated_at,
      _record.data_points_id,
      _record.display,
      _record.metadata,
      _record.kind,
      _record.loading,
      _record.content,
      _record.answer,
    );
  }
}

export function change_thread(message, thread_id) {
  if (message instanceof CopilotMessage) {
    let _record = message;
    return new CopilotMessage(
      _record.id,
      _record.org_id,
      thread_id,
      _record.user_id,
      _record.created_at,
      _record.updated_at,
      _record.data_points_id,
      _record.display,
      _record.metadata,
      _record.kind,
    );
  } else {
    let _record = message;
    return new CopilotQuestion(
      _record.id,
      _record.org_id,
      thread_id,
      _record.user_id,
      _record.created_at,
      _record.updated_at,
      _record.data_points_id,
      _record.display,
      _record.metadata,
      _record.kind,
      _record.loading,
      _record.content,
      _record.answer,
    );
  }
}

export function conversation_ids(message) {
  if (message instanceof CopilotMessage) {
    let $ = $string.split(message.thread_id, "_");
    if ($ instanceof $Empty) {
      return new Error(undefined);
    } else {
      let $1 = $.tail;
      if ($1 instanceof $Empty) {
        return new Error(undefined);
      } else {
        let $2 = $1.tail;
        if ($2 instanceof $Empty) {
          return new Error(undefined);
        } else {
          let $3 = $2.tail;
          if ($3 instanceof $Empty) {
            let proposal_id = $.head;
            let question_id = $1.head;
            return new Ok([proposal_id, question_id]);
          } else {
            return new Error(undefined);
          }
        }
      }
    }
  } else {
    return new Error(undefined);
  }
}

export function should_send(copilot_message) {
  return $metadata.should_send(copilot_message.metadata);
}

export function is_assistant(copilot_message) {
  let $ = copilot_message.metadata;
  if ($ instanceof $metadata.Deprecated) {
    return false;
  } else if ($ instanceof $metadata.Errored) {
    return false;
  } else if ($ instanceof $metadata.System) {
    return false;
  } else if ($ instanceof $metadata.Developer) {
    return false;
  } else if ($ instanceof $metadata.User) {
    return false;
  } else if ($ instanceof $metadata.Tool) {
    return false;
  } else {
    return true;
  }
}

export function select_remove_add_sources(old_ids, new_ids) {
  let rm = $list.filter(
    old_ids,
    (dp) => { return !$list.contains(new_ids, dp); },
  );
  let add = $list.filter(new_ids, (dp) => { return !$list.contains(rm, dp); });
  return [rm, add];
}

export function diff_sources(old, new$) {
  let $ = new$.metadata;
  if ($ instanceof $metadata.Deprecated) {
    return [toList([]), toList([])];
  } else if ($ instanceof $metadata.Errored) {
    return [toList([]), toList([])];
  } else if ($ instanceof $metadata.System) {
    return [toList([]), toList([])];
  } else if ($ instanceof $metadata.Developer) {
    return [toList([]), toList([])];
  } else if ($ instanceof $metadata.User) {
    return [toList([]), toList([])];
  } else if ($ instanceof $metadata.Tool) {
    return [toList([]), toList([])];
  } else {
    let $1 = $.context;
    if ($1 instanceof Some) {
      let context = $1[0];
      return select_remove_add_sources(
        old.data_points_id,
        context.data_points_id,
      );
    } else {
      return [toList([]), toList([])];
    }
  }
}
